function cleaningList(list) {
    if (!list.length) return list
    var first = list.splice(0, 1)[0],

        data = {
            title: first.title,
            type: first.type,
        }


    switch (data.type) {
        case 'nested':
            if (!first.call_to_actions.length || !Object.keys(first.call_to_actions[0]).length) {
                data.call_to_actions = []
            } else {
                data.call_to_actions = cleaningList(first.call_to_actions.slice(0))
            }
            break
        case 'postback':
            data.payload = first.payload
            break
        case 'web_url':
            data.url = first.url
            data.webview_height_ratio = first.webview_height_ratio
            break
    }

    return [].concat(data, cleaningList(list))
}

export function filterMenus(menus) {
    if (!menus.length) return menus
    var menu = menus.splice(0, 1)[0],
        data = {
            locale: menu.locale,
            composer_input_disabled: menu.composer_input_disabled,
            call_to_actions:
                menu.call_to_actions.length && Object.keys(menu.call_to_actions[0]).length
                    ? cleaningList(menu.call_to_actions.slice(0))
                    : [],
        }
    return [].concat(data, filterMenus(menus))
}

